module.exports = "/_next/static/images/7efb16ccd7946720d7c2ff2d5dc0d7ef-icon-1.svg";